import { AxiosResponse } from 'axios';
import customerApi from '../api/customerApi';
import { EditPasswordParams } from '../model/editPassword';
import HttpStatus from '../model/enums/httpStatus';
import { User } from '../model/user';
import { Customer } from '../model/customer';

export const CustomerService = () => {
    const save = async (user: User): Promise<any> => {
        try {
            const result: AxiosResponse<any> = await customerApi.save(user);
            console.log('result ', result);
            if (result.status === HttpStatus.OK && result.data != null) {
                return Promise.resolve(result.data);
            } else if (result.status === HttpStatus.UNAUTHORIZED) {
                // TODO: Talvez um midleware que exibe um toast de acordo com o status seria interessante.
                return Promise.reject({ status: 401 } as AxiosResponse);
            } else {
                return Promise.reject({ status: 400 } as AxiosResponse);
            }
        } catch (error) {
            console.error(error);
            return Promise.reject(error);
        }
    };
    const activeCustomer = async (key: string): Promise<any> => {
        try {
            const result: AxiosResponse<any> = await customerApi.activateCustomer(key);
            console.log('result ', result);
            if (result.status === HttpStatus.OK) {
                return Promise.resolve();
            } else if (result.status === HttpStatus.UNAUTHORIZED) {
                return Promise.reject({ status: 401 } as AxiosResponse);
            } else {
                return Promise.reject({ status: 400 } as AxiosResponse);
            }
        } catch (error) {
            console.error(error);
            return Promise.reject(error);
        }
    };
    const indicateFriend = async (email: string): Promise<any> => {
        try {
            const result: AxiosResponse<any> = await customerApi.indicateFriend(email);
            if (result.status === HttpStatus.OK) {
                return Promise.resolve();
            } else if (result.status === HttpStatus.UNAUTHORIZED) {
                return Promise.reject({ status: 401 } as AxiosResponse);
            } else {
                return Promise.reject({ status: 400 } as AxiosResponse);
            }
        } catch (error) {
            console.error(error);
            return Promise.reject(error);
        }
    };

    const editPassword = async (params: EditPasswordParams): Promise<any> => {
        try {
            const result: AxiosResponse<any> = await customerApi.editPassword(params);
            console.log('result ', result);
            if (result.status === HttpStatus.OK && result.data != null) {
                return Promise.resolve(result.data);
            } else if (result.status === HttpStatus.UNAUTHORIZED) {
                // TODO: Talvez um midleware que exibe um toast de acordo com o status seria interessante.
                return Promise.reject({ status: 401 } as AxiosResponse);
            } else {
                return Promise.resolve(result.data);
            }
        } catch (error) {
            console.error(error);
            return Promise.reject(error);
        }
    };

    return {
        save,
        activeCustomer,
        indicateFriend,
        editPassword
    };
};

export default CustomerService();
